import apex from "../apex/index"

export default apex
